"use strict";

exports.__esModule = true;
exports.useAccessors = void 0;

var helpers = _interopRequireWildcard(require("./dataHelpers"));

var _react = require("react");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var useAccessors = function useAccessors(textField, valueField) {
  return (0, _react.useMemo)(function () {
    return {
      text: function text(item) {
        return helpers.dataText(item, textField);
      },
      value: function value(item) {
        return helpers.dataValue(item, valueField);
      },
      indexOf: function indexOf(data, item) {
        return helpers.dataIndexOf(data, item, valueField);
      },
      matches: function matches(a, b) {
        return helpers.valueMatcher(a, b, valueField);
      },
      findOrSelf: function findOrSelf(data, item) {
        return helpers.dataItem(data, item, valueField);
      },
      includes: function includes(data, item) {
        return helpers.dataIndexOf(data, item, valueField) !== -1;
      }
    };
  }, [textField, valueField]);
};

exports.useAccessors = useAccessors;